<template>
  <modal-template
    ref="modal"
    size="lg"
    title="Status para os projetos"
    type-modal="status_modal"
  >
    <div class="modal-content__main">
      <d-form @submit.prevent="save" :validated="hasErrors">
        <d-form-row>

          <!-- Nome -->
          <d-col md="9" class="form-group">
            <label for="name">Nome</label>
            <d-form-input
              :state="hasErrorFiled('name')"
              type="text"
              id="name"
              placeholder="Nome"
              v-model="model.name"
            />
            <d-form-invalid-feedback>Nome é obrigatório</d-form-invalid-feedback>
          </d-col>

        </d-form-row>
        <d-form-row>

          <!-- Icon -->
          <d-col md="9" class="form-group">
            <label for="icon">
              Ícone
              <a class="link" target="_blank" href="https://material.io/resources/icons/?style=baseline">Lista de ícones</a>
            </label>
            <d-form-input
              :state="hasErrorFiled('icon')"
              type="text"
              id="icon"
              placeholder="Nome"
              v-model="model.icon"
            />
            <d-form-invalid-feedback>Ícone é obrigatório</d-form-invalid-feedback>
          </d-col>
          <!-- Icon -->
          <d-col md="3" class="form-group text-center">
            <label class="d-block">Visualização</label>
            <span><i class="material-icons">{{ model.icon }}</i></span>
          </d-col>

        </d-form-row>

      </d-form>
    </div>

    <div slot="actions" class="modal-content__control" >
      <loader v-if="loading" :fullPage="false" class="mr-4"/>
      <d-button
        type="button"
        :disabled="loading"
        @click="save()"
        class="btn btn-sm btn-primary"
      >Salvar</d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import { stringfy } from '_utils';
import Events from '_utils/events';
import Loader from '_shared/Loader.vue';
import ValidateForm from '_common/mixins/ValidateForm';
import ModalTemplate from '_shared/Modal.vue';
import ProjectService from '_services/rest/modules/project';
import { _SAVE_STATUS_SUCCESS_, _SELECTED_STATUS_, MODEL_STATUS } from './ProjectModel';

export default {
  data() {
    return {
      loading: false,
      errors: {
        name: { required: false },
        icon: { required: false },
      },
      model: { ...MODEL_STATUS },
    };
  },
  mixins: [ValidateForm],
  components: {
    Loader,
    ModalTemplate,
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    save() {
      this.model.slug = stringfy(this.model.name);
      ProjectService.saveStatus(this.model)
        .then(response => {
          Events.$emit(_SAVE_STATUS_SUCCESS_, response);
          this.model = { ...MODEL_STATUS };
          this.submitted = false;
          this.setToggle({ type: 'status_modal', bool: false });
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        });
    },
  },
  mounted() {
    Events.$on(_SELECTED_STATUS_, model => {
      this.model = model;
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.modal-content__control {
  display: flex;
  justify-content: flex-end;
}
.link {
  cursor: pointer;
  color: $primary;
  font-size: 0.7rem;
  margin-left: 10px;
  &:hover {
    text-decoration: underline;
  }
}
.material-icons {
  font-size: 1.7rem;
}
</style>
